<template>
	<div class="login">
		<div class="login-header">
			<img src="../assets/logo.png" />
			<span>您身边的文印专家</span>
		</div>
		<div class="login-body">
			<!-- <img class="login-body-left" src="../assets/login-p1.jpg" /> -->
			<div class="login-body-left">
				<div class="login-body-left-title">窝趣虚拟驱动打印</div>
				<div class="login-body-left-tip">OFFICE、WPS等软件中直接打印，方便快捷！</div>
				<div class="login-body-left-content">
					<div class="login-body-left-content-left">
						<div :class="{top1:index == 1,top2:index == 2,top3:index==3}"></div>
					</div>
					<div class="login-body-left-content-right">
						<div class="login-body-left-content-right-step1">
							<span>下载、安装打印机虚拟驱动程序</span>
              <img src="../assets/icons/download.png" />
              <a href="https://weixinprintfile1.woquyun.com/files/p1/20200321/窝趣云打印虚拟打印机v1.0.3-win11.zip" class="underline">windows11</a>
							<img src="../assets/icons/download.png" />
							<a href="https://weixinprintfile1.woquyun.com/files/p1/20200321/窝趣云打印虚拟打印机v1.0.3-win10.zip" class="underline">windows10</a>
							<img src="../assets/icons/download.png" />
							<a href="https://weixinprintfile1.woquyun.com/files/p1/20200321/窝趣云打印虚拟打印机v1.0.3-win7.zip" class="underline">window7</a>
						</div>
						<div>在office、wps等软件中直接选择“窝趣云打印”打印机打印</div>
						<div>在自助打印机处扫描打印</div>
					</div>
				</div>
			</div>
			<div class="login-body-right">
				<div class="login-body-right-title">窝趣网页版打印/文库管理</div>
				<div class="login-body-right-info">微信扫描下方二维码登录窝趣文印PC版，无需安装任何驱动，可直接在网页上上传文件和管理自己的文库</div>
				<img class="login-body-right-qrcode" :class="{show:qrcode}" :src="qrcode" />
				<div class="login-body-right-tip">
					<img src="../assets/login-scan.png" />
					<div>打开<span class="blue">手机微信</span>扫一扫登录</div>
				</div>
			</div>
		</div>
		<div class="login-footer">
			@ 窝趣2019 苏ICP备15040413号
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				loginToken: 1,
				qrcode: '',
				index: 1,
			}
		},
		mounted() {
			this.loginToken = this.utils.generateUUID();
			this.utils.requestBlob(this.api.loginQrCode, 'get', {
				loginToken: this.loginToken
			}).then(res => {
				this.qrcode = window.URL.createObjectURL(res)
			})

			let interval = setInterval(() => {
				this.utils.request('v1.0/cust/query-login-ret', 'get', {
					loginToken: this.loginToken
				}).then((res) => {
					if (res.custId) {
						clearInterval(interval);
						localStorage.setItem('token',res.utoken)
						this.$router.push({
							path: '/index',
						})

					}
				})
			}, 2000)

			setInterval(() => {
				this.index++;
				if(this.index == 4) {
					this.index = 1;
				}
			}, 3000)
		},
		methods: {
			...mapMutations(['setRequestHeader']),
		},
	}
</script>

<style lang="less">
	@font-face {
		font-family: myFirstFont;
		src: url('../assets/fonts/fzzzjh.TTF')
	}

	.login {

		.blue {
			color: #409EFF;
		}

		.underline {
			text-decoration: underline;
			cursor: pointer;
		}

		&-header {
			padding: 30px 40px;
			font-family: myFirstFont;

			img {
				width: 70px;
				vertical-align: bottom;
				margin-right: 8px;
			}

			span {
				color: #f9750a;
				font-size: 26px;
				font-weight: bold;
			}
		}

		&-body {
			display: flex;
			box-sizing: border-box;
			// justify-content: space-between;
			box-sizing: border-box;
			background-color: #409EFF;
			padding: 120px 120px 120px 80px;
			margin-bottom: 30px;
			background: url(../assets/login-bg.png) 100% 100%;

			&-left {
				font-size: 18px;
				color: #fff;

				&-title {
					font-size: 28px;
					font-family: myFirstFont;
				}

				&-tip {
					margin: 20px 0 40px 0;
					color: rgba(255,255,255,0.8);
				}

				&-content {
					display: flex;
					color: rgba(255,255,255,0.8);

					&-left {
						width: 3px;
						height: 200px;
						background-color: #b1b4b3;
						margin-right: 20px;

						&>div {
							height: 66px;
							width: 100%;
							position: relative;
							background-color: #fff;
							// animation: move 4s linear 2s infinite;
							// -moz-animation: move 4s linear 2s infinite;
							// -webkit-animation: move 4s linear 2s infinite;
							// -o-animation: move 4s linear 2s infinite;
							transition: all 0.5s;
						}

						.top1 {
							top: 0px;
						}
						.top2 {
							top: 66px;
						}
						.top3 {
							top: 132px;
						}
					}

					&-right {
						line-height: 40px;

						&>div {
							margin-bottom: 32px;
						}

						&-step1 {
							display: flex;
							align-items: center;
						}

						img {
							width: 30px;
							margin: 0 8px 0 16px;
						}
					}
				}
			}

			&-right {
				background-color: #fff;
				width: 340px;
				padding: 20px 20px;
				margin: auto;
				box-sizing: border-box;
				text-align: center;
				border-radius: 4px;

				&-title {
					color: #f0731e;
					font-size: 20px;
					border-bottom: 1px solid #f0731e;
					padding-bottom: 10px;
					letter-spacing: 2px;
					font-family: myFirstFont;
				}

				&-info {
					text-align: center;
					font-size: 12px;
					line-height: 20px;
					margin-top: 10px;
				}

				&-qrcode {
					width: 160px;
					height: 160px;
					margin: 10px 0;
					visibility: hidden;
				}

				.show {
					visibility: visible;
				}

				&-tip {
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 14px;

					&>img {
						width: 20px;
						margin-right: 6px;
						vertical-align: middle;
					}
				}
			}
		}

		&-footer {
			text-align: center;
			color: #c0c4cc;
			font-size: 14px;
		}

		@keyframes move {
			0% {
				top: 0px;
			}

			33% {
				top: 66px;
			}

			66% {
				top: 132px;
			}
		}

		@-moz-keyframes move {
			0% {
				top: 0px;
			}

			33% {
				top: 66px;
			}

			66% {
				top: 132px;
			}
		}

		@-webkit-keyframes move {
			0% {
				top: 0px;
			}

			33% {
				top: 66px;
			}

			66% {
				top: 132px;
			}
		}

		@-o-keyframes move {
			0% {
				top: 0px;
			}

			33% {
				top: 66px;
			}

			66% {
				top: 132px;
			}
		}
	}
</style>
